export * from './dispatch-note-details-content';
